<app-admin-detail-shell
  titleKey="ADMIN.USERS.DETAIL.PROFILE.TITLE"
  descriptionKey="ADMIN.USERS.DETAIL.PROFILE.DESCRIPTION"
  [showBack]="true"
  [backLink]="backLink"
  contextLabelKey="ADMIN.USERS.DETAIL.CURRENT_USER_LABEL"
  [contextValue]="userDisplayName"
  [tabs]="tabs"
></app-admin-detail-shell>
